module.exports = __webpack_public_path__ + "img/bg.52c76d7a.jpg";